import { TSwipeSide } from '../types';

type TCallback = (side: TSwipeSide) => void;

export function addSwipeListener(element: HTMLElement, callback: TCallback): () => void {
  let isScrolling = false;
  let scrollLeft = element.scrollLeft;

  const scrollListener = () => {
    isScrolling = true;
  };

  const touchendListener = () => {
    if (isScrolling) {
      isScrolling = false;

      const currentLeftScroll = element.scrollLeft;

      if (currentLeftScroll > scrollLeft) {
        callback('right');
      }

      if (currentLeftScroll < scrollLeft) {
        callback('left');
      }

      scrollLeft = currentLeftScroll;
    }
  };

  element.addEventListener('scroll', scrollListener, { passive: true });
  element.addEventListener('touchend', touchendListener, { passive: true });

  return () => {
    element.removeEventListener('scroll', scrollListener);
    element.removeEventListener('touchend', touchendListener);
  };
}
